export default __webpack_public_path__ + "static/media/tempering-icon-dark.8790e850.svg";